
//  document.addEventListener("DOMContentLoaded", function() {
//     var messages = document.querySelectorAll('.message');
//     var currentMessage = 0;

//     messages[currentMessage].classList.add('active');

//     function changeMessage(next = true) {
//         messages[currentMessage].classList.remove('active');

//         if (next) {
//             currentMessage = (currentMessage + 1) % messages.length;
//         } else {
//             currentMessage = (currentMessage - 1 + messages.length) % messages.length;
//         }

//         messages[currentMessage].classList.add('active');
//     }

//     var interval = setInterval(changeMessage, 3000);

//     document.querySelector('.left-arrow').addEventListener('click', function() {
//         changeMessage(false);
//         resetInterval();
//     });

//     document.querySelector('.right-arrow').addEventListener('click', function() {
//         changeMessage(true);
//         resetInterval();
//     });

//     function resetInterval() {
//         clearInterval(interval);
//         interval = setInterval(changeMessage, 3000);
//     }
// });

document.addEventListener("DOMContentLoaded", function() {
    var messages = document.querySelectorAll('.message');
    var currentMessage = 0;
    messages[currentMessage].classList.add('active');

    function changeMessage(next = true) {
        messages[currentMessage].classList.remove('active');
        currentMessage = (currentMessage + (next ? 1 : -1) + messages.length) % messages.length;
        messages[currentMessage].classList.add('active');
    }

    var interval;
    if (window.innerWidth <= 780) {
        interval = setInterval(changeMessage, 3000);
    }

    window.addEventListener('resize', function() {
        var width = window.innerWidth;
        if (width <= 780 && !interval) {
            interval = setInterval(changeMessage, 3000);
        } else if (width > 780 && interval) {
            clearInterval(interval);
            interval = null;
        }
    });
});
